export default __webpack_public_path__ + "static/media/Icon12.9264441d.svg";